import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useGetCapacityAlertSettings = (
  enabled: boolean = true
): QueryReturnType<any> => {
  return useQuery<never, never, any>([ENDPOINTS.CAPACITY_ALERT_SETTINGS], {
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
  });
};
